module.exports = __webpack_public_path__ + "img/askPriceDesc1.fbee9c28.png";